/**
 * Sites plan limits (castr `api/sites.js`): the `sites` / `maxSites` gate on
 * POST /sites and the `sites:custom-domain` gate on custom domains.
 */

export const SITES_NOT_IN_PLAN = 'sites_not_in_plan'
export const SITES_LIMIT_REACHED = 'sites_limit_reached'

// castr's /subscriptions/packages omits package definitions, so the dashboard
// cannot tell which plan includes Sites; upgrades land on the plan picker.
export const SITES_UPGRADE_PATH = '/subscribe'

export const COUNTS_TOWARD_LIMIT = 'Drafts and disabled sites count toward the limit.'

/**
 * Why castr refused POST /sites on plan grounds, or null for any other error.
 * castr builds before the reason codes only send the Boom message.
 * @return {'limit'|'not-in-plan'|null}
 */
export function sitesPlanRefusal(err) {
	if (!err) return null
	if (err.reason === SITES_LIMIT_REACHED) return 'limit'
	if (err.reason === SITES_NOT_IN_PLAN) return 'not-in-plan'
	if (err.code !== 403) return null
	const message = String(err.message || '')
	if (/create more sites/i.test(message)) return 'limit'
	if (/subscription to create sites/i.test(message)) return 'not-in-plan'
	return null
}

const sitesNoun = (n) => (n === 1 ? 'site' : 'sites')

/** Title + body of the upgrade popup for a blocked "New Site". */
export function sitesUpgradeCopy(kind, { limit } = {}) {
	if (kind === 'limit') {
		const included = limit ? `Your plan includes ${limit} ${sitesNoun(limit)} and all of them are in use` : 'All the sites your plan includes are in use'
		return {
			title: 'Site limit reached',
			body: `${included} — drafts and disabled sites count too. Upgrade your plan to create more, or delete a site you no longer need.`,
		}
	}
	return {
		title: 'Upgrade to create sites',
		body: 'Sites are not included in your current plan. Your existing sites stay listed here; upgrade to create new ones.',
	}
}

/** "3 sites · custom domains included" for the Sites header. */
export function sitesPlanLine({ maxSites, customDomain }) {
	const sites = maxSites ? `${maxSites} ${sitesNoun(maxSites)}` : 'Sites'
	return `${sites} · custom domains ${customDomain ? 'included' : 'not included'}`
}
